import { render } from "./About.vue?vue&type=template&id=261da61d"
const script = {}
script.render = render

export default script